<template>
  <div class="infoContract">
    <div class="infoContract__title">{{ headInfo }}</div>
    <div class="infoContract__itemContainer">
      <div v-for="(item, key) in infoData" :key="key" class="infoContract__item">
        <div class="infoContract__itemTitle">{{ item.title }}</div>
        <div class="infoContract__itemText">{{ item.value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoComponents",
  props: ["infoData", "headInfo"],
  data: function() {
    return {
      visible: false
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped>
</style>